const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || '';

export const API_BASE_URL = rawBaseUrl.replace(/\/$/, '');

function resolveUrl(path) {
  if (/^https?:\/\//.test(path)) {
    return path;
  }
  return `${API_BASE_URL}${path}`;
}

export async function apiRequest(path, options = {}) {
  const url = resolveUrl(path);
  let response;

  try {
    response = await fetch(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });
  } catch (error) {
    console.error(`API request failed before a response was received: ${url}`, error);
    const networkError = new Error(
      'Unable to reach the server. Check your API base URL, backend availability, and browser CORS settings.'
    );
    networkError.code = 'network_error';
    networkError.url = url;
    throw networkError;
  }

  const isJson = response.headers.get('content-type')?.includes('application/json');
  const payload = isJson ? await response.json() : await response.text();

  if (!response.ok) {
    const detail = typeof payload === 'object' && payload?.detail ? payload.detail : 'Request failed';
    console.error(`API request failed: ${url}`, { status: response.status, payload });
    throw new Error(detail);
  }

  return payload;
}
